import { ReactNode } from "react";
import { TdhEntryMode } from "../../types/types";

type TdhModeSelectorProps = {
	mode: TdhEntryMode;
	knownTdh: string;
	onModeChange: (mode: TdhEntryMode) => void;
	onKnownTdhChange: (value: string) => void;
	helpDescription?: string;
};

export function TdhModeSelector({
	mode,
	knownTdh,
	onModeChange,
	onKnownTdhChange,
	helpDescription = "Not sure what head your pump needs to overcome? Select this option to estimate total dynamic head (TDH) based on your application and discharge piping details."
}: TdhModeSelectorProps) {
	return (
		<fieldset
			className="pf-tdh-mode-grid"
			aria-labelledby="tdh-mode-label"
		>
			<legend id="tdh-mode-label" className="pf-sr-only">
				TDH entry method
			</legend>
			<TdhModeCard
				title="I know my TDH"
				isActive={mode === "known"}
				onClick={() => onModeChange("known")}
			>
				<label className="pf-tdh-mode-card__field">
					<span className="pf-tdh-mode-card__field-label">TDH</span>
					<input
						type="number"
						className="pf-input"
						value={knownTdh}
						onChange={(event) => onKnownTdhChange(event.target.value)}
						onFocus={() => onModeChange("known")}
						min="0"
						step="any"
					/>
				</label>
			</TdhModeCard>

			<TdhModeCard
				title="Calculate TDH"
				isActive={mode === "help"}
				onClick={() => onModeChange("help")}
				describedBy="tdh-help-description"
			>
				<p id="tdh-help-description" className="pf-tdh-mode-card__description">
					{helpDescription}
				</p>
			</TdhModeCard>
		</fieldset>
	);
}

type TdhModeCardProps = {
	title: string;
	isActive: boolean;
	onClick: () => void;
	describedBy?: string;
	children: ReactNode;
};

function TdhModeCard({
	title,
	isActive,
	onClick,
	describedBy,
	children,
}: TdhModeCardProps) {
	const classes = [
		"pf-tdh-mode-card",
		isActive ? "pf-tdh-mode-card--active" : "",
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div
			className={`pf-tdh-mode-option${isActive ? " pf-tdh-mode-option--active" : ""}`}
			onClick={onClick}
		>
			<button
				type="button"
				className={classes}
				aria-pressed={isActive}
				aria-describedby={describedBy}
			>
				<h3 className="pf-tdh-mode-card__title">{title}</h3>
			</button>
			{children}
		</div>
	);
}
